import { hexTransition } from './factories/ColorFactory';

export const COLORS = ['#57324C', '#6B6041', '#2F504A', '#185B63', '#19375f'];

export const colorBlend = function(level) {
  let blended = [];
  const set = Math.floor(level/(COLORS.length - 1));
  const setRemainder = level % (COLORS.length - 1);

  COLORS.forEach((color, i) => {
    if (i < COLORS.length - 2) {
      blended = blended.concat([...hexTransition(color, COLORS[i+1], set)]);
    } else if (i === COLORS.length - 2) {
      blended = blended.concat([...hexTransition(color, COLORS[i+1], set + setRemainder)]);
    }
  });

  return blended;
};



// WEBPACK FOOTER //
// ./src/utilities/color/ColorTools.js